module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-container"
  }, [_c('el-form', {
    ref: "registerForm",
    staticClass: "register-form",
    attrs: {
      "autoComplete": "on",
      "model": _vm.registerForm,
      "rules": _vm.registerRules,
      "label-position": "left"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("科乐支付平台")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_register"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "user"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "username",
      "type": "text",
      "autoComplete": "off",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.registerForm.username),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "username", $$v)
      },
      expression: "registerForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "code",
    attrs: {
      "prop": "verificationCode"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_register"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "envelope-open"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "inputCode",
      "type": "text",
      "autoComplete": "off",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.registerForm.verificationCode),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "verificationCode", $$v)
      },
      expression: "registerForm.verificationCode"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "get-code",
    attrs: {
      "disabled": _vm.isDisable
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendSmsCode('registerForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCode_btn))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "svg-container svg-container_register"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "lock"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "name": "password",
      "type": _vm.pwdType,
      "autoComplete": "off",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.registerForm.password),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "password", $$v)
      },
      expression: "registerForm.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    on: {
      "click": _vm.showPwd
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "eye"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "sign-up",
    attrs: {
      "type": "primary",
      "native-type": "submit",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleRegister($event)
      }
    }
  }, [_vm._v("\n        注册\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("已有账号,返回登录")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42bfc62b","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/register.vue
// module id = Ri8M
// module chunks = 3